module.exports = __webpack_public_path__ + "static/media/GPC_BigOne.6e286153.png";